import React from "react";
import AppointmentHero from "../sections/AppointmentHero";
import Schedule from "../sections/Schedule";
import ContactMap from "../sections/ContactMap";
import Contact from "../sections/Contact";

const Appointment = () => {
  return (
    <div>
      <AppointmentHero />
      <Schedule />
      <ContactMap />
      <Contact />
    </div>
  );
};

export default Appointment;
